import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BudgetService } from '../../../service/budget.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-budget-month',
  templateUrl: './budget-month.component.html',
  styleUrls: ['./budget-month.component.less']
})
export class BudgetMonthComponent implements OnInit {

  seletedMonth = 5;
  // 接受
  @Input() bid: any;
  @Input() mbid: any;
  @Input() byear: any;
  months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

 constructor(
    private budgetService: BudgetService,
    private nzMessageService: NzMessageService,
  ) {
  }

  ngOnInit(): void {
    if (this.mbid !== undefined) {
      this.loadData();
    } else {
      this.seletedMonth =  + 1 ;
    }
  }

  // 若为编辑修改功能，需要现货区当前记录的所属年份的月度预算
  async loadData(): Promise<boolean> {
    const obj = await this.budgetService.getBudgetMonthByMbid(this.mbid);
    if (obj) {
      this.seletedMonth = obj.bmonth;
      return true;
    }
    return false;
  }

  async edit(): Promise<boolean> {

    // 获取月度预算列表
    // const parentList = await this.budgetService.getBudgetMonthsByBid(this.bid);

    // // 获取月份列表
    // const months = new Set<number>();
    // parentList.forEach(item => {
    //   months.add(new Date(Date.parse(item.month)).getMonth() + 1);
    // });
    // if (!months.has(this.seletedDate.getMonth() + 1)) {
    //   // 该月不存在，无法修改
    //   return false;
    // }

    // let flag = false;
    // if (this.mbid) {
    //   const date = `${this.seletedDate.getFullYear()}-${this.seletedDate.getMonth() + 1}-${this.seletedDate.getDate()}`;
    //   const time = `${this.seletedDate.getHours()}:${this.seletedDate.getMinutes()}:${this.seletedDate.getSeconds()}`;
    //   const str = `${date} ${time}`;
    //   const obj = {
    //     mbid: this.mbid,
    //     bname: `${this.seletedDate.getMonth() + 1}月预算`,
    //     currentValue: this.demoValue,
    //     bid: this.bid,
    //     month: str,
    //     createTime: str,
    //     updateTime: str
    //   };
    //   flag = await this.budgetService.updateBudgetMonth(obj);
    // }
    // // 返回操作结果
    // return flag;
    return false;
  }

   async check(): Promise<boolean> {
    // 获取月度预算列表
    const parentList = await this.budgetService.getBudgetMonthsByBid(this.bid);

    // 获取月份列表
    const months = new Set<number>();
    parentList.forEach(item => {
      months.add(Number(item.bmonth));
    });

    let flag = false;

    if (months.has( this.seletedMonth)) {
      this.nzMessageService.error('该月预算已经存在');
    } else {
      const obj = {
        bname: `${this.seletedMonth}月预算`,
        currentValue: 0,
        bid: this.bid,
        bmonth: this.seletedMonth,
      };
      flag = await this.budgetService.addBudgetMonth(obj);
    }
    return flag;
  }

}
